import { API, Item } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  sectionId: string;
  headingId: Item["uuid"];
  displayOrder: string; // (after|before):Item["uuid"]
};

const [useReorderHeading, reorderHeading] = createAsyncAction(
  "items/reorderHeading",
  async ({ headingId, displayOrder }: Args) => {
    return await API.call<{ items: string[] }>({
      endpoint: `headings/${headingId}/reorder`,
      method: "PUT",
      data: {
        position: displayOrder,
      },
    });
  }
);
export default useReorderHeading;
export { reorderHeading };
